import Image from 'next/image'

export function BrandMark({ light = false }: { light?: boolean }) {
  return (
    <span className={`brand-mark ${light ? 'brand-mark--light' : ''}`} aria-label="Trellis Tables">
      <Image src="/trellis-logo.svg" alt="" aria-hidden="true" width={446} height={140} loading="eager" />
      <span>tables</span>
    </span>
  )
}
